require.register("app/product/price/new/ConfigTab", function(exports, require, module){
  $0
  
});

